module.exports = __webpack_public_path__ + "pa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/pa.svg
// module id = 748
// module chunks = 0